/**
 * Banner — inline message strip. For top-of-page or top-of-form context.
 *
 * Tones map to status palette: info | success | warning | danger.
 * Optional leading icon, optional dismiss button, optional action button.
 */

import { HiOutlineXMark } from 'react-icons/hi2'

const TONES = {
  info:    { wrap: 'bg-info-soft    border-info/30    text-info',    iconText: 'text-info' },
  success: { wrap: 'bg-success-soft border-success/30 text-success', iconText: 'text-success' },
  warning: { wrap: 'bg-warning-soft border-warning/30 text-warning', iconText: 'text-warning' },
  danger:  { wrap: 'bg-danger-soft  border-danger/30  text-danger',  iconText: 'text-danger' },
  brand:   { wrap: 'bg-brand-soft   border-brand/30   text-brand',   iconText: 'text-brand' },
}

export default function Banner({
  tone = 'info',
  icon: Icon,
  title,
  children,
  action,
  onDismiss,
  className = '',
}) {
  const t = TONES[tone] || TONES.info
  return (
    <div
      role={tone === 'danger' || tone === 'warning' ? 'alert' : 'status'}
      className={`flex items-start gap-3 p-3 sm:p-4 border rounded-xl ${t.wrap} ${className}`}
    >
      {Icon && <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${t.iconText}`} aria-hidden="true" />}
      <div className="flex-1 min-w-0">
        {title && <p className="font-medium text-sm">{title}</p>}
        {children && <div className={`text-sm ${title ? 'mt-0.5' : ''}`}>{children}</div>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className={`p-1 rounded hover:bg-black/5 dark:hover:bg-white/10 transition-colors ${t.iconText}`}
        >
          <HiOutlineXMark className="w-4 h-4" />
        </button>
      )}
    </div>
  )
}
